/**
 * 목록 loader 의 첫 페이지 — 서버는 기다려 본문까지 그리고, 브라우저 이동은 기다리지 않는다.
 *
 * 목록 화면은 머리(head)가 데이터에 기대지 않는다. 브라우저에서 기다리면 필터 · 탭을 누를 때
 * 이전 화면이 멈춰 있다. 기다리지 않으면 주소가 바로 바뀌고 목록이 제자리에서 「불러오는 중」을
 * 보인다(useInfiniteQuery 의 isLoading — 이전과 같은 동작).
 */
export async function awaitOnServer(first: Promise<unknown>): Promise<void> {
  if (import.meta.env.SSR) await first;
  else void first.catch(() => undefined);
}
